export const iconFontAwesomeToggleLocationCrosshairs = (
	<i className="fa-solid fa-location-crosshairs"></i>
);
